import { useQuery } from "react-query"

import axios from "ApiServices/axios"
import { Api } from "Constants/api"
import { FEATURE_FLAGS } from "Constants/queryKeys"

interface IFeatureFlags {
  is_allowed_to_use_payment_free_month: boolean
}

const getFeatureFlags = async () => {
  const { data } = await axios.get<IFeatureFlags>(Api.FeatureFlags)
  return data
}

export const useFeatureFlags = () =>
  useQuery({
    queryKey: [FEATURE_FLAGS],
    queryFn: getFeatureFlags,
  })
